import { Tab, Tabs, Typography } from '@mui/material'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod/v3'
import { AuthorizedButtonLink, withRoutePermissions } from '~/utils/rbac'
import TabPanel from '../../../components/containers/TabPanel'
import PlusIcon from '../../../components/icons/PlusIcon'
import Page from '../../../components/Page'
import { EstablishmentsPanel } from '../../../components/routes/sellers/EstablishmentsPanel'
import { SellersPanel } from '../../../components/routes/sellers/SellersPanel'
import { useRights } from '../../../utils/hooks'
import { fonts } from '../../../utils/theme/fonts.theme'
const tabs = ['sellers', 'establishments'] as const

export const Route = createFileRoute('/_authenticated/sellers/')({
  staticData: {
    permission: ['read', 'sellers'],
  },
  component: SellersPage,
  validateSearch: z.object({
    tab: z.enum(tabs).optional(),
  }),
})
withRoutePermissions(Route)

function SellersPage() {
  const isAdmin = useRights(['ADMIN'])

  const { tab = 'sellers' } = Route.useSearch()

  const navigate = Route.useNavigate()

  const handleChange = (newValue: number) => {
    const newTab = tabs.at(newValue)
    navigate({ search: { tab: newTab } })
  }

  return (
    <Page>
      <div style={{ display: 'flex' }}>
        <Typography style={fonts.pageTitle} flexGrow={1}>
          Vendeurs
        </Typography>

        {tab === 'sellers' && (
          <AuthorizedButtonLink variant="contained" to="/sellers/new" disabled={!isAdmin}>
            <PlusIcon />
            Ajouter un vendeur
          </AuthorizedButtonLink>
        )}
        {tab === 'establishments' && (
          <AuthorizedButtonLink
            variant="contained"
            to="/sellers/establishment/new"
            disabled={!isAdmin}
          >
            <PlusIcon />
            Ajouter un établissement
          </AuthorizedButtonLink>
        )}
      </div>

      <Tabs value={tabs.indexOf(tab)} onChange={(_, newValue) => handleChange(newValue)}>
        <Tab label="Vendeurs" />
        <Tab label="Établissements" />
      </Tabs>

      <TabPanel value={tab} index="sellers">
        <SellersPanel />
      </TabPanel>

      <TabPanel value={tab} index="establishments">
        <EstablishmentsPanel />
      </TabPanel>
    </Page>
  )
}
